import { EventEmitter, Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-schedulecheckbox',
  templateUrl: './schedulecheckbox.component.html',
  styleUrls: ['./schedulecheckbox.component.css']
})
export class SchedulecheckboxComponent implements OnInit {
  @Input() controlName : string = "";
  @Input() controlValue : string = "";
  @Output() cbapplyChanged = new EventEmitter();

  public form: FormGroup;
  public control : FormControl;

  
  
  constructor(private controlContainer: ControlContainer) { }

  ngOnInit() {
    this.form = <FormGroup>this.controlContainer.control;
    
    this.control = <FormControl>this.form.controls[this.controlName];

    //this.control = <FormControl>this.form.get('sun1');
    this.controlValue=this.control.value;
      console.log(this.controlValue)
    

  }

  
  fnApplyChanges()
  {
    
    if(this.controlValue ==='')
    {
      this.controlValue='HOLI'
    }
    else if(this.controlValue ==='HOLI')
    {
      this.controlValue='HALF'
    }
    else if(this.controlValue ==='HALF')
    {
      this.controlValue='WORK'
    }
    else if(this.controlValue ==='WORK')
    {
      this.controlValue='HOLI'
    }
    console.log(this.control)

    this.control.setValue(this.controlValue);

   
    
  }

  

}
